import { IntervalObservable } from "rxjs/observable/IntervalObservable";

export class TableView {
    public filter: Filter = new Filter;
    public source: Function;
    public items: Array<any> = [];
    public total: number = 0;
    public updating: Promise<any>;
    private sub: any;

    constructor(source: Function) {
        this.source = source;
        this.filter.onChange = () => { 
            this.applyFilter(); 
        };
    }

    public refreshEvery(seconds: number = 0) {
        if (seconds) {
            this.sub = IntervalObservable.create(seconds*1000).subscribe(n => {
                this.applyFilter(true);
                console.log(`It's been ${(n+1)*seconds} seconds since subscribing!`);
            });
        } else {
            if (this.sub) {
                this.sub.unsubscribe();
                this.sub = null;
            }
        }
    } 

    public applyFilter(silent: boolean = false) {
        this.filter.page = +this.filter.page;
        this.filter.perPage = +this.filter.perPage;

        let promise = this.source(this.filter).then(result => {
            this.items = result.items;
            this.total = result.total;
        });

        if (!silent) {
            this.updating = promise;
        }        
    }

    public getPages(): Array<number> {
        let pages: Array<number> = [];
        if (this.total) {
            let totalPages = this.filter.perPage > 0 ? Math.ceil(this.total / this.filter.perPage) : 1;
            
            for (let i: number = 0; i < totalPages ; i++) {
                pages[i] = i+1;
            }
        }
        return pages;
    }

    public setPage(page: number) {
        //if (this.filter.page !== page) {
            this.filter.page = page;
            this.applyFilter();
        //}
    }
}

export class Filter {
    public sortBy: string = 'id';
    public sortAsc: boolean = true;
    public search: string = '';
    public perPage: number = 10;
    public page: number = 1;
    public status: number = 1;  
    onChange: Function;
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/helpers/tableview.ts